// extracted by mini-css-extract-plugin
module.exports = {"container":"Ld","copy":"Md","field":"Nd","error":"Od","disabled":"Pd","termsContainer":"Qd","termsHeading":"Rd","termsCopy":"Sd","submit":"Td","srOnly":"Ud"};